import React from 'react';
import { Trophy, X } from 'lucide-react';

const Header = ({ setCurrentPage, goToLeaderboard, mobileMenuOpen, setMobileMenuOpen }) => {
  return (
    <header className="bg-white/95 backdrop-blur-sm shadow-lg fixed top-0 left-0 right-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <button
              onClick={() => {
                setCurrentPage('home');
                setMobileMenuOpen(false);
              }}
              className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
            >
              PortfolioMaths
            </button>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-baseline space-x-8">
            <button
              onClick={() => setCurrentPage('blog')}
              className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors"
            >
              Blog
            </button>
            <button
              onClick={() => setCurrentPage('jobs')}
              className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors"
            >
              Jobs
            </button>
          </div>
          
          {/* Desktop Right Buttons */}
          <div className="hidden md:flex items-center gap-4">
            <button
              onClick={goToLeaderboard}
              className="flex items-center gap-2 text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors"
            >
              <Trophy className="w-4 h-4" />
              Leaderboard
            </button>
            <button 
              onClick={() => setCurrentPage('practice')}
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-full text-sm font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition-all"
            >
              Get Started
            </button>
          </div>
          
          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
        
        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-2">
              <button
                onClick={() => {
                  setCurrentPage('blog');
                  setMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors text-left"
              >
                Blog
              </button>
              <button
                onClick={() => {
                  setCurrentPage('jobs');
                  setMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors text-left"
              >
                Jobs
              </button>
              <button
                onClick={() => {
                  goToLeaderboard();
                  setMobileMenuOpen(false);
                }}
                className="flex items-center gap-2 text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors"
              >
                <Trophy className="w-4 h-4" />
                Leaderboard
              </button>
              <button 
                onClick={() => {
                  setCurrentPage('practice');
                  setMobileMenuOpen(false);
                }}
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-full text-sm font-semibold hover:shadow-lg transition-all mx-3 mt-2"
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;